"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var wagtailConfig_1 = require("../../config/wagtailConfig");
var Icon_1 = __importDefault(require("../../components/Icon/Icon"));
/**
 * A loading indicator with a text label next to it.
 */
var LoadingSpinner = function () { return (react_1["default"].createElement("span", null,
    react_1["default"].createElement(Icon_1["default"], { name: "spinner", className: "c-spinner" }), " " + wagtailConfig_1.STRINGS.LOADING)); };
exports["default"] = LoadingSpinner;
